<template>
  <div id="app">
    <div class="fullpage-content">
      <div class="header-content">
        <Header />
      </div>
      <div class="main-content">
        <router-view class="router-content" />
      </div>
    </div>
  </div>
</template>

<script>
import Header from './components/AppHeader.vue';

export default {
  components: {
    Header,
  },
};
</script>

<style>
html,
body {
  height: 100vh;
  /* Ensure full height of the viewport */
  width: 100%;
  margin: 0;
  /* Remove default margin */
  padding: 0;
  /* Remove default padding */
}

#app {
  width: 100%;
  height: 100%;
}

.fullpage-content {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.header-content {
  width: 100%;
}

.main-content {
  flex: 1;
  width: 100%;
  min-height: 200px;
}

.router-content {
  width: 100%;
  height: 100%;
}
</style>